import RequestClass from '@api/request/RequestClass';
import {API_NAMESPACE} from '@constants/general';
import {METHOD_POST} from '@constants/http';
import type {GetCurrentUserClubInfoResponse, GetCurrentUserInfoResponse} from '@interfaces/Api';
import type {EmptyRestApiResponse} from '@interfaces/RestApiResponse';

export async function getCurrentUserInfo(): Promise<GetCurrentUserInfoResponse> {
    return (await new RequestClass(`${API_NAMESPACE}/user/current`)
        .setVersionHeader(2)
        .send()) as Promise<GetCurrentUserInfoResponse>;
}

export async function getCurrentUserClubInfo(): Promise<GetCurrentUserClubInfoResponse> {
    return (await new RequestClass(
        `${API_NAMESPACE}/user/current/club`,
    ).send()) as Promise<GetCurrentUserClubInfoResponse>;
}

export async function saveCurrentUser(
    email: string,
    password: string,
    token: string,
): Promise<EmptyRestApiResponse> {
    return (await new RequestClass(`${API_NAMESPACE}/user/current`, METHOD_POST)
        .setAuthHeader(token)
        .setParams({email, password})
        .send()) as Promise<EmptyRestApiResponse>;
}
